import { API_PATHS, ROUTE_PARAMS, interpolatePathParams } from '@futrli/shared-services';
import { Accounts, QueryParams } from '../types';
import { makeRequestWithResponse } from './shared';

/**
 * Get the list of accounts available for use in settings
 *
 * @param {string} workspaceId - workspace to get default-accounts from
 * @param {string} organisationId - organisation to get default-accounts from
 * @param {string} forecastId - forecast to get default-accounts from
 * @param {QueryParams} queryParams
 * @throws error
 * @returns Promise<Accounts>
 */
export const fetchAccounts = async (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  queryParams: QueryParams = {}
): Promise<Accounts> => {
  const path = interpolatePathParams(API_PATHS.ACCOUNTS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId,
  });

  return makeRequestWithResponse<Accounts>({ params: queryParams, url: path, method: 'GET' });
};
